import { render, staticRenderFns } from "./ReferrerDesc.vue?vue&type=template&id=344993ce&scoped=true"
import script from "./ReferrerDesc.vue?vue&type=script&lang=js"
export * from "./ReferrerDesc.vue?vue&type=script&lang=js"
import style0 from "./ReferrerDesc.vue?vue&type=style&index=0&id=344993ce&prod&lang=scss&scoped=true"
import style1 from "./ReferrerDesc.vue?vue&type=style&index=1&id=344993ce&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "344993ce",
  null
  
)

export default component.exports